/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/Add';
import BorderButton from '@app/components/atoms/BorderButton';
import { useTranslation } from '../../../config/i18n';
import VideoItem from './VideoItem';
import { Container, ElementContainer } from './style';

const VideoLink = ({ value, onAddLink, name, onRemoveClick, onChange, disabled }) => {
  const { t } = useTranslation(['wizard', 'applications', 'common']);

  return (
    <ElementContainer>
      <Container>
        {value.length > 0 &&
          value.map((video, index) => (
            <VideoItem
              key={`video-${index}`}
              index={index}
              value={video}
              onChange={onChange}
              onRemoveClick={onRemoveClick}
            />
          ))}
      </Container>
      <BorderButton
        id="add-video"
        name={name}
        aria-label="add"
        onClick={onAddLink}
        disabled={disabled}
        startIcon={<AddIcon />}
        variant="text"
        color="primary"
      >
        {t('add_link')}
      </BorderButton>
    </ElementContainer>
  );
};

VideoLink.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onAddLink: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

VideoLink.defaultProps = {
  value: [],
  disabled: false,
};

export default VideoLink;
